@if (!enableZonesAndDienstenFilter || (zones && diensten)) {
  <div class="filters">
    <div>
      <mat-form-field>
        <mat-label>Achternaam</mat-label>
        <input matInput
          [ngModel]="clientenFilter.getClientAchternaam()"
          (ngModelChange)="clientenFilter.setClientAchternaam($event)"
          (keyup.enter)="onSearch()"
          type="text"
          placeholder="Garcia">
        @if (!clientenFilter.isAchternaamSearchValid()) {
          <mat-hint class="error-color">Typ min twee letters</mat-hint>
        }
      </mat-form-field>
    </div>
    <div>
      <mat-form-field>
        <mat-label>Cliëntnummer</mat-label>
        <input matInput
          [ngModel]="clientenFilter.getClientnummer()"
          (ngModelChange)="clientenFilter.setClientnummer($event)"
          (keyup.enter)="onSearch()"
          type="text"
          placeholder="2020/125414">
        </mat-form-field>
      </div>
      @if (enableZonesAndDienstenFilter) {
        <div>
          <mat-form-field>
            <mat-label>Zone</mat-label>
            <mat-select [value]="clientenFilter.getZoneId()"
              (valueChange)="clientenFilter.setZoneId($event)">
            <mat-option>Alle zones</mat-option>
            @for (zone of zones; track zone) {
              <mat-option
                [value]="zone.getId()">
                {{ zone.getLabel() }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Dienst</mat-label>
          <mat-select [value]="clientenFilter.getDienstId()"
            (valueChange)="clientenFilter.setDienstId($event)">
            <mat-option>Alle diensten</mat-option>
            @for (dienst of diensten.getDiensten(); track dienst) {
              <mat-option
                [value]="dienst.getId()">
                {{ dienst.getLabel() }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    }
  </div>
  <div>
    <button mat-button
      (click)="onResetSearch()">
      Reset
    </button>
    <button mat-raised-button
      color="primary"
      (click)="onSearch()">
      Zoek
    </button>
  </div>
}
